export const PRODUCT_TYPE_NAMES = {
  GUIDED_PROJECT: 'GUIDED PROJECT',
  SELF_PACED_PROJECT: 'PROJECT',
  COURSE: 'COURSE',
  SPECIALIZATION: 'SPECIALIZATION',
  CERTIFICATE: 'CERTIFICATE',
  MASTERTRACK: 'MASTERTRACK',
  DEGREE: 'DEGREE',
} as const;

export type ProductTypeName = keyof typeof PRODUCT_TYPE_NAMES;

export const ProductVariantNames = {
  BachelorsDegree: 'BachelorsDegree',
  MastersDegree: 'MastersDegree',
  Mastertrack: 'MasterTrack',
  PostgraduateDiploma: 'PostgraduateDiploma',
  GraduateCertificate: 'GraduateCertificate',
  UniversityCertificate: 'UniversityCertificate',
} as const;

export type ProductVariantName = keyof typeof ProductVariantNames;

// scale from 1 to 3
export const domainBackgroundScoreMap: Record<string, { url: string; bannerUrl: string; score: number }> = {
  'arts-and-humanities': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/arts_and_humanities.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/arts_and_humanities.png',
    score: 1,
  },
  business: {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/business.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/business.png',
    score: 10,
  },
  'computer-science': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/computer_science.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/computer_science.png',
    score: 9,
  },
  'data-science': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/data_science.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/data_science.png',
    score: 11,
  },
  'information-technology': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/information_technology.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/information_technology.png',
    score: 7,
  },
  'life-sciences': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/health.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/health.png',
    score: 5,
  },
  'math-and-logic': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/math_and_logic.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/math_and_logic.png',
    score: 4,
  },
  'personal-development': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/personal_development.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/personal_development.png',
    score: 8,
  },
  'physical-science-and-engineering': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/physical_science_and_engineering.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/physical_science_and_engineering.png',
    score: 2,
  },
  'social-sciences': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/social_sciences.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/social_sciences.png',
    score: 3,
  },
  'language-learning': {
    url: 'https://s3.amazonaws.com/coursera_assets/browse/domains/language_learning.png',
    bannerUrl: 'https://s3.amazonaws.com/coursera_assets/browse/domain-banner/language_learning.png',
    score: 6,
  },
};
